"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RDPStreamImpl = void 0;
const types_1 = require("@refinitiv-data/types");
const abstract_item_stream_1 = require("./abstract-item-stream");
const rdp_protocol_1 = require("./protocol/rdp-protocol");
class RDPStreamImpl extends abstract_item_stream_1.AbstractItemStream {
    constructor(session, params) {
        super(session, new rdp_protocol_1.RdpProtocol(), params.api || types_1.DEFAULT_RDP_STREAMING_CONNECTION_NAME);
        this.params = params;
        this.itemStreamEventsEmitter = this;
        this.currentUniverse = this.params.universe;
    }
    get universe() {
        return this.currentUniverse;
    }
    onResponse(cb) {
        this.itemStreamEventsEmitter.on(types_1.RDPStreamEvent.Response, cb);
        return this;
    }
    onUpdate(cb) {
        this.itemStreamEventsEmitter.on(types_1.RDPStreamEvent.Update, cb);
        return this;
    }
    onAck(cb) {
        this.itemStreamEventsEmitter.on(types_1.RDPStreamEvent.Ack, cb);
        return this;
    }
    onAlarm(cb) {
        this.itemStreamEventsEmitter.on(types_1.RDPStreamEvent.Alarm, cb);
        return this;
    }
    onError(cb) {
        this.itemStreamEventsEmitter.on(types_1.RDPStreamEvent.Error, cb);
        return this;
    }
    onComplete(cb) {
        this.itemStreamEventsEmitter.on(types_1.RDPStreamEvent.Complete, cb);
        return this;
    }
    getStreamConnection() {
        return this.session.getRDPStreamConnection(this.params.api || types_1.DEFAULT_RDP_STREAMING_CONNECTION_NAME);
    }
    async modify(params) {
        this.params = params;
        this.currentUniverse = this.params.universe;
        return this.makeModifyRequest();
    }
    getRequestParams() {
        return {
            name: this.universe,
            domain: this.params.context,
            service: this.params.service,
            view: this.params.fields,
            parameters: this.params.parameters,
            extendedParams: this.params.extendedParams,
        };
    }
    emitMessage(message) {
        switch (message.type) {
            case types_1.RDPResponseType.Response:
                this.itemStreamEventsEmitter.emit(types_1.RDPStreamEvent.Response, message, this);
                break;
            case types_1.RDPResponseType.Ack:
                this.itemStreamEventsEmitter.emit(types_1.RDPStreamEvent.Ack, message, this);
                break;
            case types_1.RDPResponseType.Update:
                this.itemStreamEventsEmitter.emit(types_1.RDPStreamEvent.Update, message, this);
                break;
            case types_1.RDPResponseType.Alarm:
                this.itemStreamEventsEmitter.emit(types_1.RDPStreamEvent.Alarm, message, this);
        }
    }
}
exports.RDPStreamImpl = RDPStreamImpl;
//# sourceMappingURL=data:application/json;base64,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